import type { Actions } from '../actions';
import { RCV_MEMBERSHIPS_LIST } from '../actions/memberships';

/* ----------------- INITIAL STATE ----------------- */

interface SettablePermissionsState {
  settablePermissions: string[];
}

const _initialState: SettablePermissionsState = {
  settablePermissions: [],
};

/* ----------------- REDUCER ----------------- */

const settablePermissionsReducer = (
  state: SettablePermissionsState = _initialState,
  action: Actions,
): SettablePermissionsState => {
  switch (action.type) {
    case RCV_MEMBERSHIPS_LIST:
      return { ...state, settablePermissions: action.settablePermissions };

    default:
      return state;
  }
};

export default settablePermissionsReducer;
